import React from "react";

function Footer() {
    return (
        <div>
            <footer className="fixed-bottom">
                <div className="row">
                    <div className="col-12">
                        <h5>
                            Kyle Burt - Web Developer
                        </h5>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Footer;